import { Box, styled } from '@mui/material';
import { IconDownload, IconFilter } from 'assets/img';
import { useTranslation } from 'react-i18next';
import { LwIconButton, themeConfig } from 'redesign';

type PlanningToolboxExportButtonProps = {
  onClick: () => void;
};

export const PlanningToolboxExportButton = ({ onClick }: PlanningToolboxExportButtonProps) => {
  const { t } = useTranslation('ogp-screen-specific');

  return (
    <LwIconButton
      onClick={onClick}
      iconColorMode="stroke"
      color="secondary"
      size="large"
      aria-label={t('planning.toolbox.export-aria-label')}
      data-testid="planning-export-button"
    >
      <Box
        component="span"
        display="flex"
        width={themeConfig.icons.width}
        height={themeConfig.icons.height}
      >
        <IconDownload />
      </Box>
    </LwIconButton>
  );
};

type PlanningToolboxFilterButtonProps = {
  nrOfActiveFilters: number;
  onClick: () => void;
};

export const PlanningToolboxFilterButton = ({
  onClick,
  nrOfActiveFilters,
}: PlanningToolboxFilterButtonProps) => {
  const { t } = useTranslation('ogp-screen-specific');

  return (
    <FilterButtonWrapper>
      <LwIconButton
        onClick={onClick}
        iconColorMode="stroke"
        color="secondary"
        size="large"
        aria-label={t('planning.toolbox.filter-aria-label')}
        data-testid="planning-filter-button"
      >
        <Box
          component="span"
          display="flex"
          width={themeConfig.icons.width}
          height={themeConfig.icons.height}
        >
          <IconFilter />
        </Box>
      </LwIconButton>
      {nrOfActiveFilters > 0 ? (
        <FilterCount aria-label={t('planning.toolbox.filters-count-aria-label')}>
          {nrOfActiveFilters}
        </FilterCount>
      ) : null}
    </FilterButtonWrapper>
  );
};

const FilterButtonWrapper = styled(Box)({
  position: 'relative',
  display: 'flex',
});

const FilterCount = styled('span')(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.lwPrimaryAccentLight[20],
  borderRadius: theme.spacing(5),
  color: theme.palette.lwPrimaryAccentDark[100],
  display: 'flex',
  fontSize: '10px',
  fontWeight: 600,
  height: theme.spacing(5),
  justifyContent: 'center',
  minWidth: theme.spacing(5),
  padding: theme.spacing(0, 1),
  position: 'absolute',
  right: 0,
  top: 0,
  transform: 'translate(25%, -25%)',
}));
